import produce, { castDraft, } from 'immer';
import { VideosActionType, } from './actions';
const videosByThumbnailReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case VideosActionType.SET_VIDEOS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.smartModuleId] || {};
                temp[actualAction.smartModuleId] = temp2;
                actualAction.videos.forEach((video) => {
                    temp2[video.thumbnail] = video;
                });
            });
        default:
            return currentState;
    }
};
const videoKeysByHomeIdBySmartModuleIdBySearchParamsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case VideosActionType.SET_VIDEOS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.smartModuleId] || {};
                temp[actualAction.smartModuleId] = temp2;
                temp2[actualAction.searchParams] = castDraft(actualAction.videos.map((video) => {
                    return video.thumbnail;
                }));
            });
        case VideosActionType.CLEAR_VIDEOS:
            // To clear videos, we just need to clear all data for the specified projectId
            return produce(currentState, (draft) => {
                var _a;
                const actualAction = action;
                if (draft[actualAction.homeId]) {
                    (_a = draft[actualAction.homeId]) === null || _a === void 0 ? true : delete _a[actualAction.smartModuleId];
                }
            });
        default:
            return currentState;
    }
};
export const homeVideosStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.videosByThumbnailByHomeIdBySmartModuleId = videosByThumbnailReducer(currentState.videosByThumbnailByHomeIdBySmartModuleId, action);
        draft.videoKeysByHomeIdBySmartModuleIdBySearchParams = castDraft(videoKeysByHomeIdBySmartModuleIdBySearchParamsReducer(currentState.videoKeysByHomeIdBySmartModuleIdBySearchParams, action));
    });
};
